import { useUiStore } from './uiStore';

const TX_PATH = 'tx/';
const ADDRESS_PATH = 'address/';

function buildExplorerTxUrl(baseUrl?: string, txHash?: string | null) {
  if (!baseUrl || !txHash) {
    return undefined;
  }

  const normalizedBase = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
  const normalizedHash = txHash.startsWith('0x') ? txHash : `0x${txHash}`;

  return `${normalizedBase}${TX_PATH}${normalizedHash}`;
}

function buildExplorerAddressUrl(baseUrl?: string, address?: string | null) {
  if (!baseUrl || !address) {
    return undefined;
  }

  const normalizedBase = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
  const normalizedAddress = address;

  return `${normalizedBase}${ADDRESS_PATH}${normalizedAddress}`;
}

export function getBlockExplorerTxUrl(txHash?: string | null) {
  const explorerUrl = useUiStore.getState().blockExplorerUrl;
  return buildExplorerTxUrl(explorerUrl, txHash);
}

export function getBlockExplorerAddressUrl(address?: string | null) {
  const explorerUrl = useUiStore.getState().blockExplorerUrl;
  return buildExplorerAddressUrl(explorerUrl, address);
}

export function setBlockExplorerUrl(url?: string) {
  useUiStore.getState().setBlockExplorerUrl(url);
}
